<!-- COPIADO DE edit-content.component.vue -->
<template>
  <div
    class="rounded-md bg-ontick-steel-100 p-4 text-ontick-carbon-900 dark:bg-ontick-graphite-500 dark:text-gray-300"
  >
    <ontick-text size="medium" weight="medium">{{
      group.group_name
    }}</ontick-text>

    <!-- params -->
    <ontick-div
      v-for="(param, param_key) in group.group_params"
      :key="param_key"
      class="mt-3 block w-full"
    >
      <!-- Card 1 -->
      <ontick-div
        class="flex w-full items-center space-y-2"
        :class="
          param.param_type === 'bool'
            ? 'flex-row justify-between'
            : 'flex-col sm:flex-row'
        "
      >
        <ontick-div
          orientation="vertical"
          alignVertical="center"
          class="w-full pr-3"
        >
          <ontick-div orientation="horizontal" class="justify-start">
            <ontick-text
              class="mr-3 leading-normal"
              style="white-space: normal"
              >{{ param.param_name }}</ontick-text
            >
            <form-tooltip
              :value="param.param_tooltip"
              v-if="param.param_tooltip"
            ></form-tooltip>
          </ontick-div>
        </ontick-div>
        <!-- ************************************************************** -->

        <!-- +------------------------------------------------------------+ -->
        <!-- + type INTEGER || DOUBLE                                     + -->
        <!-- +------------------------------------------------------------+ -->
        <template
          v-if="param.param_type === 'integer' || param.param_type === 'double'"
        >
          <ontick-number-input
            :class="`param_${param.param_id}`"
            :value="param.param_value"
            :min="param.param_min"
            :max="param.param_max"
            :step="param.param_step"
            :disabled="info.running"
            @input="setParamById({ id: param.param_id, value: $event })"
          />
          <!-- </div> -->
        </template>

        <!-- +------------------------------------------------------------+ -->
        <!-- + type STRING                                                + -->
        <!-- +------------------------------------------------------------+ -->
        <template v-if="param.param_type == 'string'">
          <input
            type="text"
            class="bg-ontick-carbon text-ontick-base input_form focus:outline-none block w-3/5 appearance-none rounded-md px-3 py-2 text-ontick-carbon-900 focus:border-red-500 dark:text-white sm:text-sm"
            v-model="param.param_value"
            :maxlength="param.param_max"
            :disabled="info.running"
          />
        </template>

        <!-- +------------------------------------------------------------+ -->
        <!-- + type ENUM                                                  + -->
        <!-- +------------------------------------------------------------+ -->
        <!-- param_values - possui todas as opções do select -->
        <template v-if="param.param_type == 'enum'">
          <form-select
            :options="param.param_values"
            :selectedOption="param.param_value_id"
            @change="param.param_value_id = $event.param_id"
            :disabled="info.running"
          ></form-select>
        </template>

        <!-- +------------------------------------------------------------+ -->
        <!-- + type BOOL                                                  + -->
        <!-- +------------------------------------------------------------+ -->
        <template v-if="param.param_type == 'bool'">
          <form-switch
            class="w-full md:w-3/5"
            @toggle="param.param_value = !param.param_value"
            :active="param.param_value"
            :disabled="info.running"
          ></form-switch>
        </template>
      </ontick-div>
      <!-- /Card 1 -->

      <!-- param.param_value >= param.param_max && param.param_value <= param.param_min -->
      <ontick-div v-if="error_message[param.param_id]">
        <ontick-text size="small" weight="medium" color="red">{{
          error_message[param.param_id]
        }}</ontick-text>
      </ontick-div>

      <!-- +------------------------------------------------------------+ -->
      <!-- + type ENUM com sub-parâmetros                               + -->
      <!-- +------------------------------------------------------------+ -->
      <collapse-transition class="w-full">
        <template v-if="param.param_type == 'enum'">
          <ontick-div>
            <ontick-div
              v-for="(sub_param, sub_param_key) in getSelectedOption(param)"
              :key="sub_param_key"
              class="mt-3 block w-full"
            >
              <!-- ************************************************************** -->
              <!-- ************************************************************** -->
              <!-- ************************************************************** -->

              <ontick-div class="inline-flex w-full items-center">
                <ontick-div
                  orientation="horizontal"
                  alignVertical="center"
                  class="mb-1 w-2/5 justify-between pr-3"
                >
                  <ontick-text class="mr-3">{{
                    sub_param.param_name
                  }}</ontick-text>
                  <form-tooltip
                    :value="sub_param.param_tooltip"
                    v-if="sub_param.param_tooltip"
                  ></form-tooltip>
                </ontick-div>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type INTEGER || DOUBLE                                     + -->
                <!-- +------------------------------------------------------------+ -->
                <template
                  v-if="
                    sub_param.param_type == 'integer' ||
                    sub_param.param_type == 'double'
                  "
                >
                  <ontick-number-input
                    :class="`sub_param_${sub_param.param_id}`"
                    v-model="sub_param.param_value"
                    :min="sub_param.param_min"
                    :max="sub_param.param_max"
                    :step="sub_param.param_step"
                    :disabled="info.running"
                    @input="
                      setParamById({
                        id: sub_param.param_id,
                        value: $event,
                      })
                    "
                  />
                </template>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type STRING                                                + -->
                <!-- +------------------------------------------------------------+ -->
                <template v-if="sub_param.param_type == 'string'">
                  <input
                    type="text"
                    class="bg-ontick-carbon text-ontick-base input_form focus:outline-none block w-3/5 appearance-none rounded-md px-3 py-2 text-ontick-carbon-900 focus:border-red-500 dark:text-white sm:text-sm"
                    v-model="sub_param.param_value"
                    :maxlength="sub_param.param_max"
                    :disabled="info.running"
                  />
                </template>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type ENUM                                                  + -->
                <!-- +------------------------------------------------------------+ -->
                <!-- param_values - possui todas as opções do select -->
                <template v-if="sub_param.param_type == 'enum'">
                  <form-select
                    :options="sub_param.param_values"
                    :selectedOption="sub_param.param_value_id"
                    @change="sub_param.param_value_id = $event.param_id"
                    :disabled="info.running"
                  ></form-select>
                </template>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type BOOL                                                  + -->
                <!-- +------------------------------------------------------------+ -->
                <template v-if="sub_param.param_type == 'bool'">
                  <form-switch
                    @toggle="sub_param.param_value = !sub_param.param_value"
                    :active="sub_param.param_value"
                    :disabled="info.running"
                  ></form-switch>
                </template>
              </ontick-div>

              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- +------------------------------------------------------------+ -->
              <!-- + type BOOL com sub-parâmetros                               + -->
              <!-- +------------------------------------------------------------+ -->
              <collapse-transition class="w-full">
                <template v-if="sub_param.param_type == 'bool'">
                  <ontick-div
                    v-if="sub_param.param_value && sub_param.param_subparams"
                  >
                    <ontick-div
                      v-for="(
                        sub_sub_param, sub_sub_param_key
                      ) in sub_param.param_subparams"
                      :key="sub_sub_param_key"
                      class="mt-3 block w-full"
                    >
                      <!-- ************************************************************** -->
                      <!-- ************************************************************** -->
                      <!-- ************************************************************** -->

                      <ontick-div
                        class="flex w-full flex-col items-center gap-2 sm:flex-row"
                      >
                        <ontick-div
                          orientation="horizontal"
                          alignVertical="center"
                          class="mb-1 w-2/5 justify-between pr-3"
                        >
                          <ontick-text class="mr-3">{{
                            sub_sub_param.param_name
                          }}</ontick-text>
                          <form-tooltip
                            :value="sub_sub_param.param_tooltip"
                            v-if="sub_sub_param.param_tooltip"
                          ></form-tooltip>
                        </ontick-div>

                        <!-- +------------------------------------------------------------+ -->
                        <!-- + type INTEGER || DOUBLE                                     + -->
                        <!-- +------------------------------------------------------------+ -->
                        <template
                          v-if="
                            sub_sub_param.param_type == 'integer' ||
                            sub_sub_param.param_type == 'double'
                          "
                        >
                          <ontick-number-input
                            :class="`sub_sub_param_${sub_sub_param.param_id}`"
                            v-model="sub_sub_param.param_value"
                            :min="sub_sub_param.param_min"
                            :max="sub_sub_param.param_max"
                            :step="sub_sub_param.param_step"
                            :disabled="info.running"
                            @input="
                              setParamById({
                                id: sub_sub_param.param_id,
                                value: $event,
                              })
                            "
                          />
                          <!-- </div> -->
                        </template>

                        <!-- +------------------------------------------------------------+ -->
                        <!-- + type STRING                                                + -->
                        <!-- +------------------------------------------------------------+ -->
                        <template v-if="sub_sub_param.param_type == 'string'">
                          <input
                            type="text"
                            class="bg-ontick-carbon text-ontick-base input_form focus:outline-none block w-3/5 appearance-none rounded-md px-3 py-2 text-ontick-carbon-900 focus:border-red-500 dark:text-white sm:text-sm"
                            v-model="sub_sub_param.param_value"
                            :maxlength="sub_sub_param.param_max"
                            :disabled="info.running"
                          />
                        </template>

                        <!-- +------------------------------------------------------------+ -->
                        <!-- + type ENUM                                                  + -->
                        <!-- +------------------------------------------------------------+ -->
                        <!-- param_values - possui todas as opções do select -->
                        <template v-if="sub_sub_param.param_type == 'enum'">
                          <form-select
                            :options="sub_sub_param.param_values"
                            :selectedOption="sub_sub_param.param_value_id"
                            @change="param.param_value_id = $event.param_id"
                            :disabled="info.running"
                          ></form-select>
                        </template>
                      </ontick-div>

                      <!-- ************************************************************** -->
                      <!-- ************************************************************** -->
                      <!-- ************************************************************** -->
                    </ontick-div>
                  </ontick-div>
                </template>
              </collapse-transition>
              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- ++++++++++++++++++++++++++++++++ -->
              <!-- ++++++++++++++++++++++++++++++++ -->

              <!-- ************************************************************** -->
              <!-- ************************************************************** -->
              <!-- ************************************************************** -->
            </ontick-div>
          </ontick-div>
        </template>
      </collapse-transition>

      <!-- +------------------------------------------------------------+ -->
      <!-- + type BOOL com sub-parâmetros                               + -->
      <!-- +------------------------------------------------------------+ -->
      <collapse-transition class="w-full">
        <template v-if="param.param_type == 'bool'">
          <ontick-div v-if="param.param_value && param.param_subparams">
            <ontick-div
              v-for="(sub_param, sub_param_key) in param.param_subparams"
              :key="sub_param_key"
              class="mt-3 block w-full"
            >
              <!-- ************************************************************** -->
              <!-- ************************************************************** -->
              <!-- ************************************************************** -->

              <ontick-div
                class="flex w-full flex-col items-center gap-2 sm:flex-row"
              >
                <ontick-div
                  orientation="horizontal"
                  alignVertical="center"
                  class="mb-1 w-full justify-start pr-3"
                >
                  <ontick-text class="mr-3">{{
                    sub_param.param_name
                  }}</ontick-text>
                  <form-tooltip
                    :value="sub_param.param_tooltip"
                    v-if="sub_param.param_tooltip"
                  ></form-tooltip>
                </ontick-div>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type INTEGER || DOUBLE                                     + -->
                <!-- +------------------------------------------------------------+ -->
                <template
                  v-if="
                    sub_param.param_type == 'integer' ||
                    sub_param.param_type == 'double'
                  "
                >
                  <ontick-number-input
                    :class="`sub_param_${sub_param.param_id}`"
                    v-model="sub_param.param_value"
                    :min="sub_param.param_min"
                    :max="sub_param.param_max"
                    :step="sub_param.param_step"
                    :disabled="info.running"
                    @input="
                      setParamById({
                        id: sub_param.param_id,
                        value: $event,
                      })
                    "
                  />
                  <!-- </div> -->
                </template>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type STRING                                                + -->
                <!-- +------------------------------------------------------------+ -->
                <template v-if="sub_param.param_type == 'string'">
                  <input
                    type="text"
                    class="bg-ontick-carbon text-ontick-base input_form focus:outline-none block w-3/5 appearance-none rounded-md px-3 py-2 text-ontick-carbon-900 focus:border-red-500 dark:text-white sm:text-sm"
                    v-model="sub_param.param_value"
                    :maxlength="sub_param.param_max"
                    :disabled="info.running"
                  />
                </template>

                <!-- +------------------------------------------------------------+ -->
                <!-- + type ENUM                                                  + -->
                <!-- +------------------------------------------------------------+ -->
                <!-- param_values - possui todas as opções do select -->
                <template v-if="sub_param.param_type == 'enum'">
                  <form-select
                    :options="sub_param.param_values"
                    :selectedOption="sub_param.param_value_id"
                    @change="param.param_value_id = $event.param_id"
                    :disabled="info.running"
                  ></form-select>
                </template>
              </ontick-div>

              <!-- +------------------------------------------------------------+ -->
              <!-- + type ENUM com sub-parâmetros                               + -->
              <!-- +------------------------------------------------------------+ -->
              <collapse-transition class="w-full">
                <template v-if="sub_param.param_type == 'enum'">
                  <ontick-div
                    v-for="(
                      sub_sub_param, sub_sub_param_key
                    ) in getSelectedOption(sub_sub_param)"
                    :key="sub_sub_param_key"
                    class="mt-3 inline-flex w-full items-center"
                  >
                    <!-- ************************************************************** -->
                    <!-- ************************************************************** -->
                    <!-- ************************************************************** -->

                    <ontick-div
                      orientation="horizontal"
                      alignVertical="center"
                      class="mb-1 w-2/5 justify-between pr-3"
                    >
                      <ontick-text class="mr-3">{{
                        sub_sub_param.param_name
                      }}</ontick-text>
                      <form-tooltip
                        :value="sub_sub_param.param_tooltip"
                        v-if="sub_sub_param.param_tooltip"
                      ></form-tooltip>
                    </ontick-div>

                    <!-- +------------------------------------------------------------+ -->
                    <!-- + type INTEGER || DOUBLE                                     + -->
                    <!-- +------------------------------------------------------------+ -->
                    <template v-if="sub_sub_param.param_type == 'integer'">
                      <ontick-number-input
                        :class="`sub_sub_param_${sub_sub_param.param_id}`"
                        v-model="sub_sub_param.param_value"
                        :min="sub_sub_param.param_min"
                        :max="sub_sub_param.param_max"
                        :step="sub_sub_param.param_step"
                        :disabled="info.running"
                        @input="
                          setParamById({
                            id: sub_sub_param.param_id,
                            value: $event,
                          })
                        "
                      />
                      <!-- </div> -->
                    </template>

                    <!-- +------------------------------------------------------------+ -->
                    <!-- + type STRING                                                + -->
                    <!-- +------------------------------------------------------------+ -->
                    <template v-if="sub_sub_param.param_type == 'string'">
                      <input
                        type="text"
                        class="bg-ontick-carbon text-ontick-base input_form focus:outline-none block w-3/5 appearance-none rounded-md px-3 py-2 text-ontick-carbon-900 focus:border-red-500 dark:text-white sm:text-sm"
                        v-model="sub_sub_param.param_value"
                        :maxlength="sub_sub_param.param_max"
                        :disabled="info.running"
                      />
                    </template>

                    <!-- +------------------------------------------------------------+ -->
                    <!-- + type ENUM                                                  + -->
                    <!-- +------------------------------------------------------------+ -->
                    <!-- param_values - possui todas as opções do select -->
                    <template v-if="sub_sub_param.param_type == 'enum'">
                      <form-select
                        :options="sub_sub_param.param_values"
                        :selectedOption="sub_sub_param.param_value_id"
                        @change="sub_sub_param.param_value_id = $event.param_id"
                        :disabled="info.running"
                      ></form-select>
                    </template>

                    <!-- +------------------------------------------------------------+ -->
                    <!-- + type BOOL                                                  + -->
                    <!-- +------------------------------------------------------------+ -->
                    <template v-if="sub_sub_param.param_type == 'bool'">
                      <form-switch
                        @toggle="
                          sub_sub_param.param_value = !sub_sub_param.param_value
                        "
                        :active="sub_sub_param.param_value"
                        :disabled="info.running"
                      ></form-switch>
                    </template>

                    <!-- ************************************************************** -->
                    <!-- ************************************************************** -->
                    <!-- ************************************************************** -->
                  </ontick-div>
                </template>
              </collapse-transition>

              <!-- ************************************************************** -->
              <!-- ************************************************************** -->
              <!-- ************************************************************** -->
            </ontick-div>
          </ontick-div>
        </template>
      </collapse-transition>

      <ontick-div class="py-3 text-xs" v-if="param.param_obs">
        <span v-html="replaceColor(param.param_obs)"></span>
      </ontick-div>
      <!-- ************************************************************** -->
    </ontick-div>
    <!-- end of params -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";

export default {
  components: {
    FormTooltip: () => import("../form/form-tooltip.component"),
    FormSelect: () => import("../form/form-select.component"),
    FormSwitch: () => import("../form/form-switch.component"),
    PortfolioEditComponent: () => import("./portfolio-edit.component.vue"),
    CollapseTransition,
  },
  props: {
    group: {
      type: Object,
    },
  },
  data() {
    return {
      error_message: {},
    };
  },
  methods: {
    ...mapActions({ setParamById: "investment/setParamById" }),
    getSelectedOption(param) {
      let selectedOption = param.param_values.filter(
        (p) => p.param_id == param.param_value_id
      );
      return selectedOption.length > 0 ? selectedOption[0].param_subparams : [];
    },
    replaceColor(val) {
      return val.replace(
        "text-ontick-yellow-500",
        "text-ontick-yellow-800 dark:text-ontick-yellow-600"
      );
    },
  },
  computed: {
    ...mapGetters({
      section_index: "investment/getSectionIndex",
      info: "investment/getParametersInfo",
    }),
  },
};
</script>

<style></style>
